import * as React from 'react';
import * as moment from 'moment';
import IncidentUpdate from './IncidentUpdate.react';
export default function Incident(props) {


    let getIncidentStatusDisplay = (status) => {
        switch(status.toLowerCase()) {
            case 'investigating':
                return <span>Investigating</span>;
            case 'identified':
                return <span>Identified</span>;
            case 'monitoring':
                return <span>Monitoring</span>;
            case 'resolved':
                return <span>Resolved</span>;
            default:
                return <span>Unkown</span>;
        }
    }

    let getImpactDisplay = (impact) => {
        switch(impact.toLowerCase()) {
            case 'none':
                return <span style={{ color: '#2fcc66'}}>None</span>;
            case 'minor':
                return <span style={{ color: '#FFC400' }}>Minor</span>;
            case 'major':
                return <span style={{ color: '#DC9300'}}>Major</span>;
            case 'critical':
                return <span style={{ color: '#DC0000'}}>Critical</span>;
            default:
                return <span>Unkown</span>;
        }
    }

return (
<div style={{
        border: '1px solid lightgray',
        margin: '3px',
        borderRadius: '5px',
        width: '800px',
    }}>
    <div className='row' style={{
        padding: '10px',
        borderBottom: '1px solid black',
        margin: '3px',
        borderRadius: '2px',
    }}>
        <div className='col'>
            <div className='row'>
                <div className='col' style={{ fontSize: 30}}>{ props.incident.name }</div>
                <div className='col' style={{ fontSize: 20, textAlign: 'right'}}>{ moment(props.incident.created_at).format('MMM Do, LT')}</div>
            </div>
            <div className='row'>
                <div className='col'><span style={{ fontSize: 20}}>Impact: { getImpactDisplay(props.incident.impact) }</span></div>
            </div>
            <div className='row'>
                <div className='col'><span style={{ fontSize: 20}}>Status: { getIncidentStatusDisplay(props.incident.status) }</span></div>
            </div>
        </div>
    </div>
    { 
        props.incident.incident_updates.sort((a, b) => moment(a.display_at).isAfter(moment(b.display_at)) ? 1 : -1 )
        .map((incident, i) => {
            return (
                <IncidentUpdate incident={incident} />
            );
        }) 
    }
    </div>);
}


// WEBPACK FOOTER //
// ./ui_src/app/components/status/Incident.react.jsx